/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { SecurityShieldIcon16Light } from './SecurityShieldIcon16Light';
import { SecurityShieldIcon16Regular } from './SecurityShieldIcon16Regular';
import { SecurityShieldIcon16Solid } from './SecurityShieldIcon16Solid';
import { SecurityShieldIcon20Light } from './SecurityShieldIcon20Light';
import { SecurityShieldIcon20Regular } from './SecurityShieldIcon20Regular';
import { SecurityShieldIcon20Solid } from './SecurityShieldIcon20Solid';
import { SecurityShieldIcon24Regular } from './SecurityShieldIcon24Regular';
import { SecurityShieldIcon24Solid } from './SecurityShieldIcon24Solid';
import { SecurityShieldIcon32Regular } from './SecurityShieldIcon32Regular';
import { SecurityShieldIcon64Regular } from './SecurityShieldIcon64Regular';
var sizes = {
    16: {
        light: SecurityShieldIcon16Light,
        regular: SecurityShieldIcon16Regular,
        solid: SecurityShieldIcon16Solid,
    },
    20: {
        light: SecurityShieldIcon20Light,
        regular: SecurityShieldIcon20Regular,
        solid: SecurityShieldIcon20Solid,
    },
    24: {
        regular: SecurityShieldIcon24Regular,
        solid: SecurityShieldIcon24Solid,
    },
    32: {
        regular: SecurityShieldIcon32Regular,
    },
    64: {
        regular: SecurityShieldIcon64Regular,
    },
};
export var SecurityShieldIcon = forwardRef('SecurityShieldIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
